// extracted by mini-css-extract-plugin
export var alternate = "_1b-j";
export var black = "_1b-6";
export var blue = "_1b-f";
export var blueLight = "_1b-e";
export var brand = "_1b-8";
export var darkMode = "_1b-b";
export var error = "_1b-a";
export var gray = "_1b-5";
export var grayBlue = "_1b-d";
export var iconWrapper = "_1b-3";
export var inactive = "_1b-7";
export var indigo = "_1b-g";
export var orange = "_1b-i";
export var pink = "_1b-h";
export var primary = "_1b-0";
export var purple = "_1b-9";
export var success = "_1b-4";
export var warning = "_1b-c";
export var white = "_1b-1";
export var whiteSuccess = "_1b-2";